import { render, staticRenderFns } from "./AtividadesComplementares.vue?vue&type=template&id=87954f92&"
import script from "./AtividadesComplementares.vue?vue&type=script&lang=js&"
export * from "./AtividadesComplementares.vue?vue&type=script&lang=js&"
import style0 from "./AtividadesComplementares.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports